import React from "react";

export const STAGE_KEY = {
  upload: "stageUpload",
  extract: "stageExtract",
  ocr: "stageOcr",
  ai: "stageAi",
  generate: "stageGenerate",
  done: "stageDone",
};

export const stageLabel = (t, stage) => t[STAGE_KEY[stage]] || t.stageExtract;

export const ProgressBar = ({ progress = 0, label = "", className = "" }) => {
  const pct = Math.max(0, Math.min(100, Math.round(progress)));
  return (
    <div data-testid="progress-bar" className={`w-full ${className}`}>
      <div className="mb-2 flex items-center justify-between">
        <span data-testid="progress-stage" className="flex items-center gap-2 text-sm font-semibold text-slate-600">
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
          </span>
          {label}
        </span>
        <span data-testid="progress-percent" className="font-display text-sm font-extrabold tabular-nums text-emerald-700">
          {pct}%
        </span>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-slate-100 shadow-inner">
        <div
          className="dotec-progress-fill h-full rounded-full"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};
